const yup = require('yup')

const shape = {
  resort: yup.mixed(),
  metrics: yup.mixed(), // We are only reading this. No need for fine-grained schema.
  meta: yup
    .object()
    .shape({
      computedAt: yup.date(),
      triggeredBy: yup.string().oneOf(['event', 'scheduled']).default('event'),
    })
    .optional(),
  createdAt: yup.date(),
  updatedAt: yup.date(),
}

const analyticsLiveSchemaPartial = yup.object().shape(shape)
const analyticsLiveSchema = analyticsLiveSchemaPartial

module.exports = { analyticsLiveSchema, analyticsLiveSchemaPartial }
